<div class="wrapper register">
    <!-- right section -->
    <section class="subWrap" [ngClass]="isRegister ? 'register' : 'login'">
        <!-- header -->
        <header class="headerWrap">
            <div class="logo"><span><img src="../../assets/images/dgb_logo.png" alt="logo image" (click)="onClickLogo()"/></span></div>
            <!-- utility menu -->
            <div class="utilmenuWrap">
                <ul class="util_list">
                    <li><button type="button" class="btn_track" (click)="onTrackStatus()"><span>{{"REG1100.BUTTON.TRACK_YOUR_STATUS"| translate}}</span></button></li>
                </ul>
                <!-- language -->
                <div class="switch_language">
                  
                    <label (click)="onChangeLanguage('en')"><input type="radio" id="engLang" name="lang" [checked]="langCode==='en'" value="en" /><span>English</span></label>
                    <label  (click)="onChangeLanguage('km')"><input type="radio" name="lang"  id="khLang" [checked]="langCode==='km'" value="km" /><span>ខ្មែរ</span></label>
                </div>
                <!-- //language -->
                <!-- list -->
                <ul class="util_list" *ngIf="isLogin">
                    <li>
                        <button type="button" class="btn_head_login"  routerLinkActive="active" [routerLink]="menuPath.REG1000" (click)="onClickLoginPage()" >
                            <span>{{"REG1100.BUTTON.REGISTER_NEW_MERCHANT"| translate}}</span>
                        </button>
                    </li>
                </ul>
                <ul class="util_list" *ngIf="isRegister">
                    <li>
                        <button type="button"  class="btn_head_login"  routerLinkActive="active" [routerLink]="menuPath.LOG1000"  (click)="onClickRegisterPage()">
                            <span>{{ isSession ? ('REG1000.BUTTON.BACK_TO_HOME' | translate) :  ('LOG1000.LABEL.LOGIN' | translate)}}</span>
                        </button>
                    </li>
                </ul>
                <!-- //list -->
            </div>
            <!-- //utility menu -->
        </header>
        <!-- //header -->

        <!-- contents area -->
         <router-outlet></router-outlet>
        <!-- //contents area -->

        <!-- footer -->
   
        <!-- //footer -->
    </section>
    <!-- //right section -->
</div>